/**
 * WebMCP 双语助手
 * tetris 语言切换通过 URL ?lan=cn|en + reload 实现，
 * 因此工具描述与消息在注册/执行时读取当前参数即可。
 */
/* eslint-disable */
function current() {
  try {
    var p = new URLSearchParams(location.search).get('lan');
    return p === 'en' ? 'en' : 'zh';
  } catch (e) { return 'zh'; }
}
function t(zh, en) { return current() === 'en' ? en : zh; }
module.exports = { current: current, t: t };



// WEBPACK FOOTER //
// ./src/webmcp/lang.js